<template>
  <div>
    <v-row no-gutters>
      <v-col>
        <v-text-field
          autofocus
          label="Search"
          v-model.trim="search"
          outlined
          @keydown.down="focusListItem"
          class="my-2"
          hide-details
          append-icon="mdi-close"
          @click:append="search = ''"
        ></v-text-field>
      </v-col>
    </v-row>
    <div
      style="
        width: auto;
        border: 1px solid grey;
        overflow-y: scroll;
        border-radius: 5px;
      "
      class="select-wrap"
    >
      <v-list style="height: 300px;" dense>
        <v-list-item
          v-for="item in filteredItems"
          :key="item.text"
          :title="item"
          @click="$emit('select', item)"
          :class="{ inList: tempArray.includes(item) }"
        >
          <v-list-item-title v-text="item.text"></v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'SelectComponent',
  props: ['items'],
  emits: ['select'],

  data() {
    return {
      search: '',
      tempArray: [],
      multipleSelect: false,
      allowNewItem: true,
      options: []
    }
  },
  created() {
    setTimeout(() => {
      this.options = this.items
    }, 0)
  },
  computed: {
    ...mapState('columns', ['columns']),
    filteredItems: {
      get() {
        return this.options.filter((option) => {
          const value = option.text
          return value.toLowerCase().includes(this.search.toLowerCase())
        })
      },
      set() {
        return this.options
      }
    }
  },
  methods: {
    ...mapActions('columns', ['addSelectItemFirebase']),
    removeSelectItem(i) {
      this.tempArray.splice(i, 1)
    },
    addItemToSelectList() {
      if (this.search && !this.filteredItems.includes(this.search)) {
        this.addSelectItemFirebase({ key: this.colKey, value: this.search })
        this.options.push(this.search)
      }
    },
    focusListItem() {
      const list = document.querySelectorAll('.list-item')
      list[0].focus()

      list.forEach((e, i, arr) => {
        e.addEventListener('keydown', (f) => {
          if (f.key === 'ArrowDown' && i < arr.length - 1) {
            arr[i + 1].focus()
            arr[i].scrollIntoView()
          } else if (f.key === 'ArrowUp' && i > 0) arr[i - 1].focus()
          else if (f.key === 'Tab' && !this.multipleSelect) {
            f.preventDefault()
            f.stopPropagation()
            this.addToList(e.textContent)
          }
        })
      })
    }
  }
}
</script>
<style scoped>
.select-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.select-list li {
  border: 1px solid grey;
  padding: 0.8rem;
}
.select-list li:hover {
  background: rgba(197, 197, 197, 0.192);
}
/* Hide scrollbar for Chrome, Safari and Opera */
.select-wrap::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.select-wrap {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.selected {
  border: 1px solid black;
  border-radius: 20px;
  margin-left: 0.5rem;
}
.inList {
  background: rgba(0, 153, 255, 0.288) !important;
}
</style>
